<template>
  <div id="div-container-canvas">
    <!--    <div v-if="cameraRef && controlsRef" style="background: red;height: 800px;width: 300px;overflow:auto;">-->
    <!--      {{ cameraRef }}-->
    <!--      {{ controlsRef }}-->
    <!--    </div>-->
    <div id="PanelRight">
      <button class="btn btn-outline-light btn-sm text-info" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
        Actions
      </button>
      <div class="collapse" id="collapseExample">
        <div class="card card-body">
          <div id="animationsPanel">
          </div>
        </div>
      </div>
    </div>
    <ComponentChatAs style="order: 2" @setStatusAnimationSpeech="setStatusAnimationSpeech"></ComponentChatAs>

    <transition name="fade">
      <div v-if="storeSettings.loadingGetters" class="loading"></div>
    </transition>
    <b-button class="btn-primary-loading" v-if="storeSettings.loadingGetters" variant="primary" disabled>
      <b-spinner small></b-spinner>
      Caricamento...
    </b-button>
  </div>
</template>

<script>
import ComponentChatAs from "@/components/chat/ComponentChatAs";
import {useSettings} from "@/stores/settings";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import * as THREE from "three";
import {ref} from "vue";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import Stats from "three/examples/jsm/libs/stats.module";
import {Vector3} from "three";
import {useApiSettingStore} from "@/stores/apiSettings";
// eslint-disable-next-line no-unused-vars
import {MeshoptDecoder} from "three/examples/jsm/libs/meshopt_decoder.module.js";

export default {
  name: "ComponentAvatar",
  components: {ComponentChatAs},
  setup() {
    let cameraRef, controlsRef, scene, renderer, clock, stats;
    let ambientLight, directionalLight, light1, light2, light3;
    let mixer;
    let modelReady = false;
    const loader = new GLTFLoader();
    loader.setMeshoptDecoder(MeshoptDecoder);
    let av;

    function getConfigurationSettings() {
      let optimizedSuffix = ''
      // let compressionSuffix = ''
      // let optimizedSuffix = '.low'
      let compressionSuffix = '_gltfpack_c_kn_km'
      let avatar_filename = null

      // at this point is not needed
      // if (useApiSettingStore().isMobileGetters) {
      //   optimizedSuffix = '.low'
      //   compressionSuffix = '_gltfpack_c_kn_km'
      // }

      switch (useSettings().genderGetters) {
        case 'm':
          avatar_filename = './avatar_uomo_classic' + compressionSuffix + optimizedSuffix + '.glb'
          break
        case 'f':
          avatar_filename = './avatar_donna_classic' + compressionSuffix + optimizedSuffix + '.glb'
          break
        default:
          avatar_filename = './avatar_uomo_classic' + compressionSuffix + optimizedSuffix + '.glb'
          break
      }
      return {
        "avatar_filename": avatar_filename
      }
    }

    let config = getConfigurationSettings()

    init()
    animate()

    function init() {
      scene = new THREE.Scene()
      // scene.add(new THREE.AxesHelper(5))

      ambientLight = new THREE.AmbientLight(0x343434, 1.0)
      ambientLight.position.set(0, 0, 0)
      scene.add(ambientLight)

      // directionalLight = new THREE.DirectionalLight(0xffffff, 2.5)
      // directionalLight.position.set(5, 10, 7.5)
      // directionalLight.castShadow = true
      // directionalLight.decay = 2.0
      // directionalLight.shadow.bias = -0.002
      // directionalLight.shadow.mapSize.set(512, 512);
      // scene.add(directionalLight)

      light1 = new THREE.PointLight(0xffffff, 1.5)
      light1.position.set(0.728, 1.981, 2.521)
      light1.castShadow = true
      light1.decay = 2.0
      light1.shadow.bias = -0.002
      // light1.shadow.mapSize.set(512, 512);
      scene.add(light1)

      // const pointLightHelper1 = new THREE.PointLightHelper( light1 );
      // scene.add( pointLightHelper1 );

      light2 = new THREE.PointLight(0xffffff, 0.5)
      light2.position.set(-1.776, 0.937, -2.411)
      light2.castShadow = true
      light2.decay = 2.0
      light2.shadow.bias = -0.002
      // light2.shadow.mapSize.set(512, 512);
      scene.add(light2)

      // const pointLightHelper2 = new THREE.PointLightHelper( light2 );
      // scene.add( pointLightHelper2 );

      light3 = new THREE.PointLight(0xffffff, 0.5)
      light3.position.set(2.964, 1.714, -1.510)
      light3.castShadow = true
      light3.decay = 2.0
      light3.shadow.bias = -0.002
      // light3.shadow.mapSize.set(512, 512);
      scene.add(light3)

      // const pointLightHelper3 = new THREE.PointLightHelper( light3 );
      // scene.add( pointLightHelper3 );

      cameraRef = ref(new THREE.PerspectiveCamera(22, window.innerWidth / window.innerHeight, 0.1, 1000))
      renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        sortObjects: false,
        powerPreference: "high-performance"
      })
      renderer.setSize(window.innerWidth, window.innerHeight)

      // settings for color scene and model
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.physicallyCorrectLights = false
      renderer.shadowMap.enabled = false
      // renderer.shadowMap.type = THREE.PCFSoftShadowMap
      // renderer.toneMapping = THREE.CineonToneMapping
      // renderer.toneMappingExposure = 0.84

      // settings for initial position
      controlsRef = ref(new OrbitControls(cameraRef.value, renderer.domElement))
      controlsRef.value.enabled = false

      // controlsRef.value.target.set(config.controls_target[0], config.controls_target[1], config.controls_target[2])
      // cameraRef.value.position.set(config.camera_position[0], config.camera_position[1], config.camera_position[2])
      //
      // controlsRef.value.update()
      // loader.setMeshoptDecoder(MeshoptDecoder)
      // loader.setDecoderConfig({type: 'js'});
      loader.load(
          config.avatar_filename,
          (avatar) => {
            console.error(avatar)
            mixer = new THREE.AnimationMixer(avatar.scene)
            av = avatar
            let eyeR, eyeL
            avatar.scene.traverse(function (object) {
              if (object.name === 'CC_Base_R_Eye') {
                eyeR = object
              }
              if (object.name === 'CC_Base_L_Eye') {
                eyeL = object
              }
            })

            let eyeRWorldPosition = new Vector3()
            let eyeLWorldPosition = new Vector3()
            eyeR.getWorldPosition(eyeRWorldPosition)
            eyeL.getWorldPosition(eyeLWorldPosition)

            let x = ((eyeRWorldPosition.x + eyeLWorldPosition.x) / 2)
            let y = ((eyeRWorldPosition.y + eyeLWorldPosition.y) / 2)
            let z = ((eyeRWorldPosition.z + eyeLWorldPosition.z) / 2)

            let centerEyesWorldPosition = new Vector3(x, y, z)

            let offSetY = 0
            let offSetZ = 0
            if (useApiSettingStore().isMobileGetters) {
              offSetY = 0.27
              offSetZ = 3.0
            } else {
              offSetY = 0.025
              offSetZ = 1.25
            }
            controlsRef.value.target.set(centerEyesWorldPosition.x, (centerEyesWorldPosition.y - offSetY), centerEyesWorldPosition.z)
            cameraRef.value.position.set(centerEyesWorldPosition.x, (centerEyesWorldPosition.y - offSetY), (centerEyesWorldPosition.z + offSetZ))

            controlsRef.value.update()
            avatar.scene.traverse(function (object) {
              if (object.userData.name === 'body') {
                console.warn(object)
                object.children[0].frustumCulled = false
                object.children[0].material.transparent = false
                object.children[0].material.depthTest = true
                object.children[0].material.depthWrite = true
                object.children[0].material.vertexColors = false
                object.children[0].material.reflectivity = 0.46
                object.children[0].material.roughness = 0.58
                object.children[0].material.metalness = 0.0 // era a 1.0 uomo - 0.0 donna
                object.children[0].material.normalScale.set(1.0, -1.0)
                object.children[0].material.side = THREE.FrontSide
                object.children[0].castShadow = true
                object.children[0].receiveShadow = true
              }
              if (object.userData.name === 'cloth') {
                console.warn(object)
                object.children[0].frustumCulled = false
                object.children[0].material.transparent = false
                object.children[0].material.depthTest = true
                object.children[0].material.depthWrite = true
                object.children[0].material.vertexColors = false
                object.children[0].material.reflectivity = 0.46
                object.children[0].material.roughness = 1.0
                object.children[0].material.metalness = 0.0
                object.children[0].material.normalScale.set(1.0, -1.0)
                object.children[0].material.side = THREE.FrontSide
                object.children[0].castShadow = true
                object.children[0].receiveShadow = true
              }
              if (object.userData.name === 'eye') {
                console.warn(object)
                object.children[0].frustumCulled = false
                object.children[0].material.transparent = false
                object.children[0].material.depthTest = true
                object.children[0].material.depthWrite = true
                object.children[0].material.vertexColors = false
                object.children[0].material.reflectivity = 0.46
                object.children[0].material.roughness = 0.2
                object.children[0].material.metalness = 0.0 // era a 1.0 uomo - 0.0 donna
                object.children[0].material.normalScale.set(1.0, -1.0)
                object.children[0].material.side = THREE.FrontSide
                object.children[0].castShadow = true
                object.children[0].receiveShadow = true
              }
              if (object.userData.name === 'hair') {
                console.warn(object)
                object.children[0].frustumCulled = false
                object.children[0].material.transparent = true
                object.children[0].material.alphaTest = 0.0
                object.children[0].material.depthTest = true
                object.children[0].material.depthWrite = false
                object.children[0].material.vertexColors = false
                object.children[0].material.reflectivity = 0.46
                object.children[0].material.roughness = 0.58
                object.children[0].material.metalness = 0.56
                object.children[0].material.side = THREE.DoubleSide
                object.children[0].castShadow = true
                object.children[0].receiveShadow = true
              }
              if (object.userData.name === 'ciglia') {
                console.warn(object)
                object.children[0].frustumCulled = false
                object.children[0].material.transparent = true
                object.children[0].material.alphaTest = 0.0
                object.children[0].material.depthTest = true
                object.children[0].material.depthWrite = false
                object.children[0].material.vertexColors = true
                object.children[0].material.reflectivity = 0.46
                object.children[0].material.roughness = 0.58
                object.children[0].material.metalness = 0.56
                object.children[0].material.side = THREE.DoubleSide
                object.children[0].castShadow = true
                object.children[0].receiveShadow = true
              }
            });

            if (avatar.animations.length > 0) {
              let activeAnimation = avatar.animations.find(a => a.name === "idle")
              mixer.clipAction(activeAnimation).play()

              const animationsPanel = document.getElementById('animationsPanel')
              if (animationsPanel) {
                animationsPanel.childNodes.forEach(item => {
                  item.remove()
                })
              }
              const ul = document.createElement('UL')
              const ulElem = animationsPanel.appendChild(ul)
              avatar.animations.forEach((a, i) => {
                const li = document.createElement('LI')
                const liElem = ulElem.appendChild(li)
                const checkBox = document.createElement('INPUT')
                checkBox.id = 'checkbox_' + i
                checkBox.type = 'checkbox'
                checkBox.addEventListener('change', (e) => {
                  if (e.target.checked) {
                    mixer.clipAction(avatar.animations[i]).reset()
                    mixer.clipAction(avatar.animations[i]).fadeIn(1)
                    mixer.clipAction(avatar.animations[i]).play()
                  } else {
                    mixer.clipAction(avatar.animations[i]).fadeOut(1)
                  }
                })
                liElem.appendChild(checkBox)
                const label = document.createElement('LABEL')
                label.htmlFor = 'checkbox_' + i
                label.innerHTML = a.name
                liElem.appendChild(label)
              })

            } else {
              const animationsPanel = document.getElementById('animationsPanel')
              animationsPanel.innerHTML = 'No animations found in model'
            }

            scene.add(avatar.scene)
            modelReady = true
            useSettings().loading = false
          },
          () => {
            useSettings().loading = true
          },
          () => {
          }
      )
      window.addEventListener('resize', onWindowResize, false)


      stats = Stats()
      // document.body.appendChild(stats.dom)
      clock = new THREE.Clock()
    }

    function onWindowResize() {
      let containerChatChat = document.getElementById('container-chat-chat')
      let divContainerCanvas = document.getElementById('div-container-canvas')
      if (divContainerCanvas && containerChatChat) {
        renderer.domElement.style.order = 1
        if (window.innerWidth > 991.98) {
          renderer.domElement.style.width = window.innerWidth - containerChatChat.getBoundingClientRect().width + 'px'
        } else {
          renderer.domElement.style.width = window.innerWidth + 'px'
        }
        renderer.domElement.style.height = window.innerHeight + 'px'
        containerChatChat.style.height = window.innerHeight + 'px'
        cameraRef.value.aspect = renderer.domElement.getBoundingClientRect().width / renderer.domElement.getBoundingClientRect().height
        cameraRef.value.updateProjectionMatrix()
      }
      render()
    }

    function animate() {
      requestAnimationFrame(animate)

      controlsRef.value.update()
      if (modelReady) mixer.update(clock.getDelta())
      scene.traverse(function (obj) {
        // if (obj.name === "CC_Base_Head") {
        //   obj.lookAt(cameraRef.value.position);
        // }
        if (obj.name === "CC_Base_R_Eye") {
          obj.lookAt(cameraRef.value.position);
          obj.rotateOnAxis(new THREE.Vector3(1, 0, 0), Math.PI * -0.5);
        }
        if (obj.name === "CC_Base_L_Eye") {
          obj.lookAt(cameraRef.value.position);
          obj.rotateOnAxis(new THREE.Vector3(1, 0, 0), Math.PI * -0.5);
        }
      })

      render()
      stats.update()
    }

    function render() {
      renderer.render(scene, cameraRef.value)
    }

    // evento ascoltato dal ComponentForm per settare l'animazione parlato quando arriva la response da dialogflow
    function setStatusAnimationSpeech(status) {
      // let talk_a = av.animations.find(a => a.name === "talk_a")
      let talk_1 = av.animations.find(a => a.name === "talk_1")
      let talk_1_ciglia = av.animations.find(a => a.name === "talk_1_ciglia")
      if (status) {
        // mixer.clipAction(talk_a).reset()
        mixer.clipAction(talk_1).reset()
        mixer.clipAction(talk_1_ciglia).reset()

        // mixer.clipAction(talk_a).fadeIn(1)
        // mixer.clipAction(talk_a).play()

        mixer.clipAction(talk_1).fadeIn(0.2)
        mixer.clipAction(talk_1).play()

        mixer.clipAction(talk_1_ciglia).fadeIn(0.2)
        mixer.clipAction(talk_1_ciglia).play()
      } else {
        // mixer.clipAction(talk_a).fadeOut(1)
        mixer.clipAction(talk_1).fadeOut(0.25)
        mixer.clipAction(talk_1_ciglia).fadeOut(0.25)
      }
    }


    return {
      setStatusAnimationSpeech,
      ambientLight,
      directionalLight,
      light1,
      light2,
      light3,
      av,
      stats,
      clock,
      controlsRef,
      renderer,
      loader,
      cameraRef,
      scene,
      mixer,
      modelReady,
    }
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
    let containerChatChat = document.getElementById('container-chat-chat')
    let divContainerCanvas = document.getElementById('div-container-canvas')
    if (divContainerCanvas && containerChatChat) {
      divContainerCanvas.appendChild(this.renderer.domElement)
      this.renderer.domElement.style.order = 1
      if (window.innerWidth > 991.98) {
        this.renderer.domElement.style.width = window.innerWidth - containerChatChat.getBoundingClientRect().width + 'px'
      } else {
        this.renderer.domElement.style.width = window.innerWidth + 'px'
      }
      this.renderer.domElement.style.height = window.innerHeight + 'px'
      containerChatChat.style.height = window.innerHeight + 'px'
      this.cameraRef.aspect = this.renderer.domElement.getBoundingClientRect().width / this.renderer.domElement.getBoundingClientRect().height
      this.cameraRef.updateProjectionMatrix()
    }
  },
  computed: {
    storeSettings() {
      return useSettings()
    },
    gender() {
      return useSettings().genderGetters
    }
  },
  watch: {
    gender: {
      handler: function (obj) {
        useSettings().isGenderModified = true;
        useSettings().systemSettingsGetters.avatar_gender_choice.value = obj;
        location.reload();
      }
    }
  },
  methods: {}
}
</script>

<style scoped>
#PanelRight {
  display: none;
}

#div-container-canvas {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
}
</style>